/**
 * Assignment mode constants for DataLeadManagement
 * Defines how data lead assignments are determined for applications
 */

/**
 * Assignment mode values used throughout the data lead management system
 */
export const ASSIGNMENT_MODES = {
  /** Data leads explicitly assigned to the application */
  CUSTOM: 'Custom',
  /** Data leads inherited from the functional area */
  DEFAULT: 'Default',
} as const;

// Type definition for assignment modes
export type AssignmentMode =
  (typeof ASSIGNMENT_MODES)[keyof typeof ASSIGNMENT_MODES];

/**
 * Display labels for assignment modes - customize these to change UI text
 */
export const ASSIGNMENT_MODE_LABELS = {
  [ASSIGNMENT_MODES.CUSTOM]: 'Assigned',
  [ASSIGNMENT_MODES.DEFAULT]: 'Default',
} as const;

/**
 * Tooltip descriptions for assignment modes
 */
export const ASSIGNMENT_MODE_TOOLTIPS = {
  [ASSIGNMENT_MODES.CUSTOM]: 'Data leads are explicitly assigned',
  [ASSIGNMENT_MODES.DEFAULT]:
    'Data leads are inherited from the functional area',
} as const;
